<div class="col-auto m-1">
  <ng-select
    [placeholder]="label"
    [disabled]="!clientId"
    [(ngModel)]="selectedClaimImport"
    (change)="onChange()">

    @for (import of claimImports; track import) {
      <ng-option [value]="import">
        <strong class="option-primary-text">{{ import.name }}</strong>
        <span class="option-secondary-text">{{ import.createdAt | date: 'MM/dd/yyyy' }} by {{ import.user.email }}</span>
      </ng-option>
    }

  </ng-select>
</div>
